/**
 * 模块说明：大目录分编管理
 */
import { Service } from '@/tools'
export class DirectoryAssembly<T extends TOrder.DirectoryAssembly> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.DirectoryAssembly}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  /* 组合商品明细  */
  assemblyDetailList = <K extends T['ApiAssemblyDetailList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAssemblyDetailList', data)
  /* 组合商品分页  */
  assemblyPage = <K extends T['ApiAssemblyPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAssemblyPage', data)
  /* 组合商品下发  */
  assemblyIssued = <K extends T['ApiAssemblyIssued']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAssemblyIssued', data, '下发成功')
  /* 组合商品导出  */
  assemblyExport = <K extends T['ApiAssemblyExport']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAssemblyExport', data, '导出成功')

  /* 组合商品转移分页  */
  transferPage = <K extends T['ApiTransferPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTransferPage', data)

  /* 转移商品组合明细  */
  transferDetail = <K extends T['ApiTransferDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTransferDetail', data)

  /* 查询选择商品是否可转移 */
  queryIsTransfer = <K extends T['ApiQueryIsTransfer']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryIsTransfer', data)
  /* 组合转移图书明细 */
  transferBookDetail = <K extends T['ApiTransferBookDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTransferBookDetail', data)
  /* 更新组合明细  */
  updateAssembly = <K extends T['ApiUpdateAssembly']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateAssembly', data)
}
